import { svg } from "lit";
const icon = svg `<path d="M5.83317 35.8336V14.0815H4.1665V4.16699H35.8331V14.0815H34.1664V35.8336H5.83317ZM7.92713 33.7396H32.0725V14.0815H7.92713V33.7396ZM6.26046 11.9875H33.7391V6.26095H6.26046V11.9875ZM15.3203 21.982H24.6793V20.0003H15.3203V21.982Z" fill="currentColor"/>`;
export default icon;
